import { useEffect, useState } from 'react';

// Revokes on change and unmount; null until the effect has run.
export function useObjectUrl(blob: Blob | null): string | null {
    const [url, setUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!blob) {
            setUrl(null);
            return;
        }
        const next = URL.createObjectURL(blob);
        setUrl(next);
        return () => URL.revokeObjectURL(next);
    }, [blob]);

    return url;
}
